<template lang="pug">

    .ui.red.small.pointing.label(v-show='isVisible' v-if="!hideMessage")
        slot

</template>

<script>
    import cond from 'lodash/fp/cond'
    import eq from 'lodash/fp/eq'

    // noinspection ReservedWordAsName
    export default {

        computed: {
            isVisible() {
                return this.$v.$dirty === true && this.$v[this.validator] === false
            }
        },

        props: {
            $v: {
                type: Object,
                required: true
            },
            hideMessage: {
                type: Boolean,
                default: false
            },
            validator: {
                type: String,
                required: true
            }
        },

        watch: {
            isVisible(isVisible) {
                const fieldEl = $(this.$el).closest('.field')

                cond([

                    // Fehler anzeigen
                    [eq(true),  () => fieldEl.addClass('error')],

                    // Fehler nicht anzeigen
                    [eq(false), () => fieldEl.removeClass('error')],

                ])(isVisible)
            }
        }

    }

</script>
